<template>
  <div class="workouts-create"> 
       <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Edit Workout" }}</h2>
            </div>
            <div class="right">
               <v-btn color="primary" @click="save" :loading="saving">{{ $page.props.lang.save || "Save" }}</v-btn>
            </div>
        </div>
        <div class="page-body">
            <v-expansion-panels elevation="1">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <template v-slot:default="{ open }">
                            General details
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row>
                            <v-col cols="8">
                                <div>
                                <label class="custom-label">{{ $page.props.lang.name || 'Name' }}</label>
                                <v-text-field v-model="form.name" 
                                    :error-messages="responseErrors.name" 
                                    :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" 
                                    outlined dense solo flat></v-text-field>
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <div>
                                    <label class="custom-label">{{ $page.props.lang.level || "Level" }}</label>
                                    <v-rating
                                        v-model="form.level"
                                        background-color="primary lighten-3"
                                        color="primary"></v-rating>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                    <label class="custom-label">{{ $page.props.lang.descrription || "Description" }}</label>
                                    <vue-editor ref="editor"
                                        v-model="form.description"
                                        :hide-details="!responseErrors.content"
                                        :error-mesasges="responseErrors.content" @focus="responseErrors.content=''">
                                    </vue-editor>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-spacer></v-spacer>
                                
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-card elevation="1" class="mt-5">
                <v-toolbar elevation="0">
                    <v-toolbar-title>{{ $page.props.lang.exercises || 'Exercises' }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <Exercises :group="index"></Exercises>
                </v-toolbar>
                <v-card-text>
                    
                </v-card-text>
            </v-card>
        
            <div class="mt-4">
                <v-btn block elevation="0" x-large outlined color="primary" @click="addGroup()">{{ $page.props.lang.new_group || "Add new group" }} </v-btn>
            </div>
        </div>
   </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout';
import { VueEditor, Quill } from "vue2-editor";
import  Exercises  from './Components/Exercises';
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Create New Workout"
        }
    },
    components: { VueEditor, Exercises },
    layout: AppLayout,
    props: {
        workout: Object
    },
    data() {
        return{
           responseErrors: {},
           form: this.workout,
           saving: false
        }
    },
    computed: {
    groups () {
        return this.$store.state.workout.groups;
    }
    },
    created() {

        this.workout.groups.forEach((group) => {
            this.$store.commit('addGroup', group);
        });

        EventBus.$on('WORKOUT_SELECTED_EXERCISES', (payload) => {

            this.addExercises(payload.e);
        });
    },
    
    methods:{
        addGroup() {
            var name = prompt("Group name:", "");

            if(name){

                axios.post('/backoffice/workouts/addGroup/'+this.workout.id, {title: name})
                .then((response) => {
                    console.log(response.data);
                    this.$store.commit('addGroup', response.data.data);
                })

                // this.$store.commit('addGroup', {
                //     name: name,
                //     exercises: []
                // })
            }
        },
        removeGroup(index){
            this.$store.commit('removeGroup', index);
        },

        addExercises(exercises) {
            axios.post('/backoffice/workouts/addExercises/'+this.workout.id, {exercises: exercises})
            .then((response) => {
                this.$store.commit('addExercise', {e: response.data.data})
            })
        },
        updateExercise(exercise_id, type, value){

            axios.post('/backoffice/workouts/updateExercise/'+exercise_id, {type: type, value: value})
            .then((response) => {
                console.log(response.data);
            })

        },
        save(){

            this.saving = true;

            axios.post('/backoffice/workouts/edit/'+this.workout.id, this.form)
            .then((response) => {
                this.saving = false;
               
            })
            .catch(error => {

                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })

            

        },
        addSet(group_index, exercise_index){

            console.log(group_index, exercise_index)

            this.$store.commit('addSet', {
                g: group_index,
                e: exercise_index
            });
            
            //exercise.sets.push(set);
        }
    }
}
</script>

<style>

</style>